export const chain = "testnet"
export const tonPytnId = "8963217838ab4cf5cadc172203c1f0b763fbaa45f346d8ee50ba994bbcac3026"
const btcId = "e62df6c8b4a85fe1a67db44dc12de5db330f7ac66b72dc658afedf0f4a415b43";
const ethId = "ff61491a931112ddf1bd8147cd1b641375f79f5825126d665480874634fd0ace";
const amznId = "b5d0e0fa58a1f8b81498ae670ce93c872d14434b72c364885d4fa1b257cbb07a";
const goldId = "765d2ba906dbc32ca17cc11f5310a89e9ee1f6420508c63861f2f8ba4ee34bb2";
const tonId = "8963217838ab4cf5cadc172203c1f0b763fbaa45f346d8ee50ba994bbcac3026";
const usdtId = "2b89b9dc8fdf9f34709a5b106b472f0f39bb6ca9ce04b0fd7f2e971688e2e53b";
const appleId = "49f6b65cb1de6b10eaf75e7c03ca029c306d0357e91b5311b175084a5ad55688";
const eurId = "a995d00bb36a63cef7fd2c287dc105fc8f3d93779f062f09551b0af3e81ec30b";
const solId = "ef0d8b6fda2ceba41da15d4095d1da392a0d2f8ed0c6c7bc0f4cfac8c280b56d"

const blankCode = "b5ee9c724101070100d9000114ff00f4a413f4bcf2c80b010202c403020009ba9696c3180201c705040010a9555f07840bf2f001dbd443a1a60663f4806043da89a1f481a9a63fa7fe600da63fa67e624304202f1a8a337539f40063f48063f48063f40063bda803a1a9a80904202f1a8a33753ed8666c4902340a098e0a27e5e8a009c61a49f60809a1da3ddaa607daa8a8caa0a4ab02d2d3da87b0bc6226ffe20aab06007c03fa403010465e321923103550527006c85005cf1613cccb1fcbff01cf16c922c8cb0112f400f400cb00c9f9007074c8cb02ca07cbffc9d024c705f2e29a350e49c3"

export const pools = [
  {
    title: "usdt",
    address: "EQBFot7L_lSA1ZpRMDqu9zmvgLFbEGWuNvAvxion9APsm2ZJ",
    icon: 'usdt.png',
    syntPythId: usdtId,
    salt: 19,
    blankCode
  },
  {
    title: "btc",
    address: "EQC3YSmTo1wNbzbqv_S_mmmu6d5zTee-eK-vh-MfoBDPREI7",
    icon: 'btc.png',
    syntPythId: btcId,
    salt: 19,
    blankCode
  },
  {
    title: "eth",
    address: "EQDOrwfCxVOs32l8ewc_qOQ_uRYekDo4cCYDmLJGOTp-OUR3",
    icon: 'eth.png',
    syntPythId: ethId,
    salt: 19,
    blankCode
  },
  {
    title: "sol",
    address: "0QDunkX0plGfw_QNvT4FKAcKW2RPpkAQacm7ue6fGJ_NJNdz",
    icon: 'sol.png',
    syntPythId: solId,
    salt: 19,
    blankCode
  },
  {
    title: "eur",
    address: "EQAwj0Erq2eegnTlFkFgt-zeHxmNFI9evM9_YH8ln8UOqFWz",
    icon: 'eur.png',
    syntPythId: eurId,
    salt: 19,
    blankCode
  },
]
